const OffsetTime = (time_str) => {
  const date_obj = new Date(time_str);
  //const time_offset = date_obj.getTimezoneOffset();

  return new Date(date_obj.getTime());
};

const options = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
};

function FormatDateTime(time_str) {
  return Intl.DateTimeFormat("ru-RU", options)
    .format(OffsetTime(time_str))
    .replace(",", "");
}

export default FormatDateTime;
